var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-2"},[_c('strong',[_vm._v(_vm._s(_vm.$t("USER_INFO")))])]),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.$t("NAME"))+": "+_vm._s(_vm.getUserName)+" ")]),_c('p',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm.$t("EMAIL"))+": "+_vm._s(_vm.getUserEmail)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }